module.exports = __webpack_public_path__ + "d2216f15876ba9719031f9d1e9c1737d.svg";